import { Link } from "react-router-dom";
import PageTitle from "../components/PageTitle";

export default function ApplyPage() {
  return (
    <>
      <PageTitle>vWZZ - Apply</PageTitle>
      <div className="page-container">
        <h1 className="page-title">START YOUR CAREER</h1>
        <p className="page-subtitle">
          Register on vAMSYS, prepare for the assessment and complete your entry
          exam through Interep.
        </p>

        {/* Its own class as well as staff-grid: these three stay side by side at every width,
            where the staff list on Contact is free to wrap. */}
        <div className="staff-grid apply-steps">
          <article className="staff-card">
            <div className="role-badge">STEP 1</div>
            <h3>Register on vAMSYS</h3>
            <div className="staff-details">
              <p className="card-body-copy">
                Create your vWZZ application through vAMSYS using your real full
                name.
              </p>
              <p className="card-body-copy compact-top">
                <span className="important-text">
                  Keep the registration pending.
                </span>{" "}
                Interep will recognise the application and provide access to the
                entry exam.
              </p>
              <a
                href="https://vamsys.io/register/vwzz"
                target="_blank"
                rel="noreferrer"
                className="btn btn-secondary btn-full"
              >
                REGISTER ON VAMSYS
              </a>
            </div>
          </article>

          <article className="staff-card">
            <div className="role-badge">STEP 2</div>
            <h3>Prepare for the exam</h3>
            <div className="staff-details">
              <p className="card-body-copy">
                Read the vWZZ OM-A REV 2 before beginning. The assessment covers
                vWZZ procedures, general aviation knowledge and A320-family
                operations.
              </p>
              <ul className="instruction-list">
                <li>
                  Use your own knowledge and the official preparation material.
                </li>
                <li>
                  Start only when you can complete the timed exam without
                  interruption.
                </li>
                <li>Close unrelated tabs and applications before beginning.</li>
              </ul>
              <a
                href="/documents/vWZZ OM-A REV 2.pdf"
                className="btn btn-secondary btn-full"
                download
              >
                DOWNLOAD <span className="brand">vWZZ</span> OM-A REV 2
              </a>
            </div>
          </article>

          <article className="staff-card">
            <div className="role-badge">STEP 3</div>
            <h3>Sign in to Interep</h3>
            <div className="staff-details">
              <p className="card-body-copy">
                Sign in with the same vAMSYS account used for your pending
                registration. Pending applicants can access only the entry exam.
              </p>
              <div className="exam-prep-note">
                The exam runs in a protected session. Tab changes, window focus
                changes, fullscreen exits and blocked clipboard actions are
                recorded for staff review.
              </div>
              <div className="detail-row score-row">
                <span className="label">Passing Score</span>
                <span className="value">75%</span>
              </div>
              <Link to="/interep/exam" className="btn btn-primary btn-full">
                OPEN ENTRY EXAM
              </Link>
            </div>
          </article>
        </div>

        <div className="general-inquiry apply-next">
          <h3>What happens next?</h3>
          <p>
            Your result is calculated when the exam is submitted and remains
            linked to your vAMSYS registration.
          </p>
          <ul className="result-list">
            <li>
              <strong>Passed?</strong> Interep requests approval of your pending
              vAMSYS registration. Sign out and back in after approval to
              refresh your access.
            </li>
            <li>
              <strong>Not passed?</strong> Interep displays whether another
              attempt is available and the exact time any configured waiting
              period ends.
            </li>
            <li>
              <strong>Approval needs attention?</strong> Your passing result
              remains saved for an administrator to review and retry safely.
            </li>
          </ul>
          <p>
            If your pending registration or exam cannot be found, contact the
            vWZZ team with your vAMSYS username.
          </p>
          <Link to="/contact" className="mail-link">
            CONTACT US
          </Link>
        </div>
      </div>
    </>
  );
}
